import React, { useState } from "react";
import Application from "./Application";
import Axios from "axios";
import { apiurl } from "../../../path";

const AdminState = (props) => {
  try {
    let token = localStorage.getItem("Token");

    const Usermenu = async () => {
      try {
        let data = await fetch(apiurl + "/GetMenu", {
          method: "POST",
          headers: { "Content-Type": "Application/json", AuthToken: token }
        });
        data = await data.json();
        return data;
      } catch (error) {
        console.error("Error in Usermenu:", error);
      }
    };

    const SearchWinner = async (Auction_ID) => {
      try {
        let data = await fetch(apiurl + "/Admin/GetWinnerList", {
          method: "POST",
          headers: { "Content-Type": "Application/json", AuthToken: token },
          body: JSON.stringify({ Auction_ID: Auction_ID }),
        });
        data = await data.json();
        return data;
      } catch (error) {
        console.error("Error in SearchWinner:", error);
      }
    };

    const Organisation = async (searchPattern) => {
      try {
        let data = await fetch(apiurl + "/Organisation", {
          method: "POST",
          headers: { "Content-Type": "Application/json", AuthToken: token },
          body: JSON.stringify({ searchPattern: searchPattern }),
        });
        data = await data.json();
        return data;
      } catch (error) {
        console.error("Error in Organisation:", error);
      }
    };

    const GetPaymentTable = async (para) => {
      try {
        let data = await fetch(apiurl + "/PaymentTable", {
          method: "POST",
          headers: ({ "Content-Type": "application/json", AuthToken: token }),
          body: JSON.stringify({ Para: para }),
        });
        data = await data.json();
        return data;
      } catch (error) {
        console.error("Error in PaymentTable:", error);
      }
    }

    const RefundTaxData = async (para) => {
      try {
        let data = await fetch(apiurl + "/RefundCheck", {
          method: "POST",
          headers: ({ "Content-Type": "application/json", AuthToken: token }),
          body: JSON.stringify({ "Tender_ID": para }),
        });
        data = await data.json();
        return data;
      } catch (error) {
        console.error("Error in PaymentTable:", error);
      }
    }

    const GetRefundFiles = async (para) => {
      try {
        let data = await fetch(apiurl + "/RefundFiles", {
          method: "POST",
          headers: ({ "Content-Type": "application/json", AuthToken: token }),
          body: JSON.stringify({ Para: para })
        });
        data = await data.json();
        return data;
      } catch (error) {
        console.error("Error in GetRefundFiles:", error);
      }
    };

    const GetAdminPassKeys = async () => {
      try {
        let data = await fetch(apiurl + "/AdminPassKeys", {
          method: "GET",
          headers: ({ AuthToken: token })
        });
        data = await data.json()
        return data;
      } catch (error) {
        console.error("Error in GetAdminPassKeys:", error);
      }
    }

    const AddAdminPassKeys = async (adminpasskeysdata) => {
      try {
        let data = await fetch(apiurl + "/AddAdminPassKeys", {
          method: "POST",
          headers: { "Content-Type": "application/json", AuthToken: token },
          body: JSON.stringify({ ...adminpasskeysdata }),
        });
        data = await data.json();
        return data;
      } catch (error) {
        console.error("Error in AddAdminPassKeys:", error);
      }
    }

    const DeleteAdminPassKeys = async (e) => {
      try {
        let data = await fetch(apiurl + "/DeleteAdminPassKeys", {
          method: "DELETE",
          headers: { "Content-Type": "application/json", AuthToken: token },
          body: JSON.stringify({ ...e })
        })
      } catch (error) {
        console.error("Error in DeleteAdminPassKeys:", error);
      }
    }

    const GetOpenTenders = async () => {
      try {
        let data = await fetch(apiurl + "/OpenTenders", {
          method: "GET",
          headers: ({ AuthToken: token })
        })
        data = await data.json()
        return data;
      } catch (error) {
        console.error("Error in GetOpenTenders:", error);
      }
    }

    const GetClosedTenders = async (searchdate) => {
      try {
        let data = await fetch(apiurl + "/ClosedTenders", {
          method: "POST",
          headers: ({ "Content-Type": "application/json", AuthToken: token }),
          body: JSON.stringify({ ...searchdate })
        })
        data = await data.json()
        return data;
      } catch (error) {
        console.error("Error in GetClosedTenders:", error);
      }
    }

    const GetAuctionsList = async (type, searchPattern) => {
      try {
        let data = await fetch(apiurl + "/Admin/Auctions", {
          method: "POST",
          headers: { "Content-Type": "Application/json", AuthToken: token },
          body: JSON.stringify({ type: type, searchPattern: searchPattern }),
        });
        data = await data.json();
        return data;
      } catch (error) {
        console.error("Error in GetAuctionsList:", error);
      }
    };
    const EditAuction = async (formdata) => {
      try {
        let data = await fetch(apiurl + "/Admin/Auctions", {
          method: "POST",
          headers: { AuthToken: token },
          body: formdata,
        });
        data = await data.json();
        console.log(data);
        return data;
      } catch (error) {
        console.error("Error in EditAuction:", error);
      }
    };
    const CreateAuction = async (formdata, EToken) => {
      try {
        let data = await fetch(apiurl + "/Admin/CreateAuction", {
          method: "POST",
          headers: { "AuthToken": token },
          body: formdata,
        });
        data = await data.json();
        return data;
      } catch (error) {
        console.error("Error in CreateAuction:", error);
      }
    };

    const AuctionWinnerDeclartionGet = async () => {
      try {
        let data = await fetch(
          apiurl + "/Admin/AuctionWinnerDeclartion",
          {
            method: "POST",
            headers: { AuthToken: token },
            body: {},
          }
        );
        data = await data.json();
        return data;
      } catch (error) {
        console.error("Error in AuctionWinnerDeclartionGet:", error);
      }
    };

    const GetWinnerDeclare = async (id) => {
      try {
        let data = await fetch(apiurl + "/Admin/GetWinnerDeclare", {
          method: "POST",
          headers: { "Content-Type": "Application/json", AuthToken: token },
          body: JSON.stringify({ id: id }),
        });
        data = await data.json();
        return data;
      } catch (error) {
        console.error("Error in GetWinnerDeclare:", error);
      }
    };

    const MakeWinner = async (formdata) => {
      try {
        let data = await fetch(apiurl + "/Admin/MakeWinner", {
          method: "POST",
          headers: { AuthToken: token },
          body: formdata,
        });
        data = await data.json();
        return data;
      } catch (error) {
        console.error("Error in MakeWinner:", error);
      }
    };
    const ReverseWinner = async (formdata) => {
      try {
        let data = await fetch(apiurl + "/Admin/ReverseWinner", {
          method: "POST",
          headers: { "Content-Type": "Application/json", AuthToken: token },
          body: JSON.stringify({ ...formdata }),
        });
        data = await data.json();
        return data;
      } catch (error) {
        console.error("Error in ReverseWinner:", error);
      }
    };

    const WinnerCrudOperations = async (type, id, form) => {
      try {
        if (type === "GetData") {
          let data = await fetch(
            apiurl + "/Admin/WinnerCrudOperations",
            {
              method: "POST",
              headers: { "Content-Type": "Application/json", AuthToken: token },
              body: JSON.stringify({ type: type, Auction_ID: id }),
            }
          );
          data = await data.json();
          return data;
        }
        if (type === "update") {
          let data = await fetch(
            apiurl + "/Admin/WinnerCrudOperations",
            {
              method: "POST",
              headers: { "Content-Type": "Application/json", AuthToken: token },
              body: JSON.stringify({
                type: type,
                ...form,
              }),
            }
          );
          data = await data.json();
          return data;
        }
      } catch (error) {
        console.error("Error in WinnerCrudOperations:", error);
      }
    };

    const ShowAuctions = async (type, item) => {
      try {
        // if (item) {
        //     let data = await Axios.post('http://' + apiurl + '/GetAuctions/ShowAuctions', { type: type, searchPattern: item }, {
        //         headers: {
        //             'Content-Type': 'Application/json'
        //         }
        //     }).then(response => {
        //         return response.data
        //     }).catch(err => {
        //         console.log(err)
        //     })
        //     return data
        // }
        // let data = await Axios.post('http://' + apiurl + '/GetAuctions/ShowAuctions', { type: type }, {
        //     headers: {
        //         'Content-Type': 'Application/json'
        //     }
        // }).then(response => {
        //     return response.data
        // }).catch(err => {
        //     console.log(err)
        // })
        // return data
      } catch (error) {
        console.error("Error in ShowAuctions:", error);
      }
    };

    const EcsRefund = async (method) => {
      if (method === "LoserRefund") {
        try {
          let refund = await Axios.post(
            apiurl + "/Admin/EcsRefund",
            { method: method },
            {
              headers: {
                "Content-Type": "Application/json",
                AuthToken: token,
              },
            }
          )
            .then((response) => {
              return response.data;
            })
            .catch((e) => {
              console.log(e);
            });
          return refund;
        } catch (error) {
          console.error("Error in EcsRefund:", error);
        }
      }
      if (method === "TenderCancelRefund") {
        try {
          let refund = await Axios.post(
            apiurl + "/Admin/EcsRefund",
            { method: method },
            {
              headers: {
                "Content-Type": "Application/json",
                AuthToken: token,
              },
            }
          )
            .then((response) => {
              return response.data;
            })
            .catch((e) => {
              console.log(e);
            });
          return refund;
        } catch (error) {
          console.error("Error in EcsRefund:", error);
        }
      }
      else {
        try {
          let refund = await Axios.post(
            apiurl + "/Admin/EcsRefund",
            {},
            {
              headers: {
                "Content-Type": "Application/json",
                AuthToken: token,
              },
            }
          )
            .then((response) => {
              return response.data;
            })
            .catch((e) => {
              console.log(e);
            });
          return refund;
        } catch (error) {
          console.error("Error in EcsRefund:", error);
        }
      }

    };

    const GenerateRefund = async (type, Auctionid) => {
      try {
        let refund = await Axios.post(
          apiurl + "/Admin/GenerateRefund",
          { type: type, Auctionid: Auctionid },
          {
            headers: {
              "Content-Type": "Application/json",
              AuthToken: token,
            },
          }
        )
          .then((response) => {
            return response.data;
          })
          .catch((e) => {
            console.log(e);
          });
        return refund;
      } catch (error) {
        console.error("Error in GenerateRefund:", error);
      }
    };
    const EcsUpload = async (data, id, AuctionName) => {
      try {
        let refund = await Axios.post(
          apiurl + "/Admin/EcsUploadfile",
          {
            data: data,
            AuctionId: id,
            AuctionName: AuctionName,
          },
          {
            headers: {
              "Content-Type": "Application/json",
              AuthToken: token,
            },
          }
        )
          .then((response) => {
            return response.data;
          })
          .catch((e) => {
            console.log(e);
          });
        return refund;
      } catch (error) {
        console.error("Error in EcsUpload:", error);
      }
    };
    const ShowRegisteredAuctionUser = async (id) => {
      try {
        let refund = await Axios.post(
          apiurl + "/Admin/ShowRegisteredAuctionUser",
          {
            AuctionId: id,
          },
          {
            headers: {
              "Content-Type": "Application/json",
              AuthToken: token,
            },
          }
        )
          .then((response) => {
            console.log(response.data);
            return response.data;
          })
          .catch((e) => {
            console.log(e);
          });
        return refund;
      } catch (error) {
        console.error("Error in ShowRegisteredAuctionUser:", error);
      }
    };

    const CompleteRefundProcess = async (Auctionid) => {
      try {
        let refund = await Axios.post(
          apiurl + "/Admin/CompleteRefundProcess",
          {
            AuctionId: Auctionid,
          },
          {
            headers: {
              "Content-Type": "Application/json",
              AuthToken: token,
            },
          }
        )
          .then((response) => {
            return response.data;
          })
          .catch((e) => {
            console.log(e);
          });
        return refund;
      } catch (error) {
        console.error("Error in CompleteRefundProcess:", error);
      }
    };

    const SendRefund = async (Data, id, tendername, textToSave, EToken) => {
      try {
        let refund = await Axios.post(
          apiurl + "/AdminRefund/RefundHash",
          {
            csvdata: Data,
            Tender_ID: id,
            Tender_Name: tendername,
            textToSave: textToSave,
          },
          {
            headers: {
              "Content-Type": "Application/json",
              AuthToken: token,
              "EToken": EToken
            },
          }
        )
          .then((response) => {
            return response.data;
          })
          .catch((e) => {
            console.log(e);
          });
        return refund;
      } catch (error) {
        console.error("Error in SendRefund:", error);
      }
    };

    const EmployeeManagement = async (type, data) => {
      try {
        if (type === "Create") {
          let Creation = await fetch(
            apiurl + "/EmployeeManagement/CreateEmployee",
            {
              method: "post",
              headers: { "Content-Type": "Application/json", AuthToken: token },
              body: JSON.stringify({ ...data, type }),
            }
          );
          Creation = await Creation.json();
          if (Creation) {
            alert("Successfully Created");
          } else {
            alert("failed Creation");
          }
        }
        if (type === "Update") {
          let Creation = await fetch(
            apiurl + "/EmployeeManagement/CreateEmployee",
            {
              method: "post",
              headers: { "Content-Type": "Application/json", AuthToken: token },
              body: JSON.stringify({ ...data, type }),
            }
          );
          Creation = await Creation.json();
          if (Creation) {
            alert("Successfully Edited");
          } else {
            alert("failed Edition");
          }
        } else if (type === "View") {
          let Creation = await fetch(
            apiurl + "/EmployeeManagement/CreateEmployee",
            {
              method: "post",
              headers: { "Content-Type": "Application/json", AuthToken: token },
              body: JSON.stringify({ Searchparameter: data, type: "View" }),
            }
          );
          Creation = await Creation.json();
          return Creation;
        }
      } catch (error) {
        console.error("Error in EmployeeManagement:", error);
      }
    };

    const Roles = async (type, data, obj) => {
      try {
        if (type === "View") {
          let Creation = await fetch(
            apiurl + "/EmployeeManagement/Roles",
            {
              method: "post",
              headers: { "Content-Type": "Application/json", AuthToken: token },
              body: JSON.stringify({ type: "View" }),
            }
          );
          Creation = await Creation.json();
          return Creation;
        } else if (type === "CreateRole") {
          let Creation = await fetch(
            apiurl + "/EmployeeManagement/Roles",
            {
              method: "post",
              headers: { "Content-Type": "Application/json", AuthToken: token },
              body: JSON.stringify({ ...data, type: "CreateRole", obj }),
            }
          );
          Creation = await Creation.json();
          console.log(Creation);
          if (Creation) {
            alert("Your Role has been Successfully Created");
          }
          return Creation;
        }
      } catch (error) {
        console.error("Error in Roles:", error);
      }
    };

    const DepartmentHandler = async (type, data, obj) => {
      try {
        if (type === "view") {
          let Creation = await fetch(
            apiurl + "/EmployeeManagement/Department",
            {
              method: "post",
              headers: { "Content-Type": "Application/json", AuthToken: token },
              body: JSON.stringify({ type: "view" }),
            }
          );
          Creation = await Creation.json();
          return Creation;
        } else if (type === "insert") {
          let Creation = await fetch(
            apiurl + "/EmployeeManagement/Department",
            {
              method: "post",
              headers: { "Content-Type": "Application/json", AuthToken: token },
              body: JSON.stringify({
                Department_Name: data,
                type: type,
                Menu_Access: obj,
              }),
            }
          );
          Creation = await Creation.json();
          if (Creation) {
            alert("Your Department has been Successfully Created");
          }
          return Creation;
        }
      } catch (error) {
        console.error("Error in DepartmentHandler:", error);
      }
    };

    const EditRoleActions = async (type, RoleID, menu, menuset) => {
      try {
        let Creation = await fetch(
          apiurl + "/EmployeeManagement/EditRole",
          {
            method: "post",
            headers: { "Content-Type": "Application/json", AuthToken: token },
            body: JSON.stringify({ type: type, RoleID: RoleID, menu, menuset }),
          }
        );
        Creation = await Creation.json();
        if (Creation === true) {
          alert("Your Role Editation has been complete");
        }
        return Creation;
      } catch (error) {
        console.error("Error in EditRoleActions:", error);
      }
    };

    const MisReports = async () => {
      try {
        let data = await fetch(apiurl + "/GetAuctions/MisReports", {
          method: "POST",
          headers: { "Content-Type": "Application/json", AuthToken: token },
          body: JSON.stringify({}),
        });
        data = await data.json();
        return data;
      } catch (error) {
        console.error("Error in MisReports:", error);
      }
    };
    const CustomeReports = async (form) => {
      try {
        let data = await fetch(
          apiurl + "/GetAuctions/CustomeReports",
          {
            method: "POST",
            headers: { "Content-Type": "Application/json", AuthToken: token },
            body: JSON.stringify({ ...form }),
          }
        );
        data = await data.json();
        return data;
      } catch (error) {
        console.error("Error in CustomeReports:", error);
      }
    };
    const WinnerRefund = async (form, EToken) => {
      console.log(form);
      console.log(EToken);

      try {
        let data = await fetch(
          apiurl + "/Admin/TenderWinnerRefund",
          {
            method: "POST",
            headers: { AuthToken: token, "EToken": EToken },
            body: form,
          }
        );
        data = await data.json();
        console.log("data", data);
        return data;
      } catch (error) {
        console.error("Error in WinnerRefund:", error);
      }
    };

    const DashboardReports = async (daterep) => {
      try {
        let data = await fetch(
          apiurl + "/GetAuctions/DashboardReports",
          {
            method: "POST",
            headers: { "Content-Type": "Application/json", AuthToken: token },
            body: JSON.stringify({ date: daterep }),
          }
        );
        data = await data.json();
        return data;
      } catch (error) {
        console.error("Error in DashboardReports:", error);
      }
    };

    const CreateToken = async (fortoken) => {
      try {
        let data = await fetch(apiurl + "/Signature/CreateToken", {
          method: "POST",
          headers: { "Content-Type": "Application/json", AuthToken: token },
          body: JSON.stringify({ fortoken: fortoken }),
        });
        data = await data.json();
        return data;
      } catch (error) {
        console.error("Error in CreateToken:", error);
      }
    };

    const AuthorizationFiles = async (fortoken) => {
      try {
        let data = await fetch(apiurl + "/Signature/Authorization", {
          method: "POST",
          headers: { "Content-Type": "Application/json", AuthToken: token },
          body: JSON.stringify({ fortoken: fortoken }),
        });
        data = await data.json();

        return data;
      } catch (error) {
        console.error("Error in AuthorizationFiles:", error);
      }
    };

    const Authorizationverify = async (Tender_ID, EToken) => {
      try {
        let data = await fetch(apiurl + "/Signature/Authorizationverify", {
          method: "POST",
          headers: { "Content-Type": "Application/json", AuthToken: token, "EToken": EToken },
          body: JSON.stringify({ Tender_ID: Tender_ID }),
        });
        data = await data.json();

        return data;
      } catch (error) {
        console.error("Error in Authorizationverify:", error);
      }
    };

    const Authorizationreject = async (Tender_ID, EToken, Remark) => {
      try {
        let data = await fetch(apiurl + "/Signature/Authorizationreject", {
          method: "POST",
          headers: { "Content-Type": "Application/json", AuthToken: token, "EToken": EToken },
          body: JSON.stringify({ Tender_ID: Tender_ID, Remark: Remark }),
        });
        data = await data.json();

        return data;
      } catch (error) {
        console.error("Error in Authorizationreject:", error);
      }
    };

    const ReUploadDocument = async (formdata) => {
      try {
        let data = await fetch(apiurl + "/Signature/ReUploadDocument", {
          method: "POST",
          headers: { AuthToken: token },
          body: formdata,
        });
        data = await data.json();

        return data;
      } catch (error) {
        console.error("Error in ReUploadDocument:", error);
      }
    };

    const ReUploadCancelDocument = async (formdata) => {
      try {
        let data = await fetch(apiurl + "/Signature/ReUploadCancelDocument", {
          method: "POST",
          headers: { AuthToken: token },
          body: formdata,
        });
        data = await data.json();

        return data;
      } catch (error) {
        console.error("Error in ReUploadCancelDocument:", error);
      }
    };

    const ApprovalRefund = async (Tender_ID) => {
      try {
        let data = await fetch(apiurl + "/AdminRefund/ApprovalRefund", {
          method: "POST",
          headers: { "Content-Type": "Application/json", AuthToken: token },
          body: JSON.stringify({ Tender_ID: Tender_ID }),
        });
        data = await data.json();
        return data;
      } catch (error) {
        console.error("Error in ApprovalRefund:", error);
      }
    };

    const GetReport = async () => {
      console.log("called");

      try {
        let data = await fetch(apiurl + "/GetReport", {
          method: "GET",
          headers: ({ AuthToken: token })
        });
        data = await data.json()
        return data;
      } catch (error) {
        console.error("Error in GetReport:", error);
      }
    }

    return (
      <Application.Provider
        value={{
          ApprovalRefund,
          Authorizationverify,
          Authorizationreject,
          CreateToken,
          DashboardReports,
          WinnerRefund,
          CustomeReports,
          MisReports,
          Roles,
          EmployeeManagement,
          SendRefund,
          ReverseWinner,
          RefundTaxData,
          CompleteRefundProcess,
          GenerateRefund,
          EcsRefund,
          ShowAuctions,
          WinnerCrudOperations,
          MakeWinner,
          GetWinnerDeclare,
          AuctionWinnerDeclartionGet,
          EditAuction,
          Usermenu,
          SearchWinner,
          Organisation,
          GetPaymentTable,
          GetRefundFiles,
          GetAdminPassKeys,
          AddAdminPassKeys,
          DeleteAdminPassKeys,
          GetOpenTenders,
          GetClosedTenders,
          GetAuctionsList,
          CreateAuction,
          EcsUpload,
          ShowRegisteredAuctionUser,
          DepartmentHandler,
          EditRoleActions,
          AuthorizationFiles,
          ReUploadDocument,
          ReUploadCancelDocument,
          GetReport
        }}
      >
        {props.children}
      </Application.Provider>
    );
  } catch (error) {
    console.error("Error in AdminState:", error);
    throw error;
  }
};
export default AdminState;
